import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["noPadding"];
import { Fragment } from "react";
import React, { useEffect } from 'react';
import { CnLayoutSection as UICnLayoutSection } from "../../components/cn-layout";
import { AddTile } from "./components/add-tile";
import { initSingletonDivider } from "../cn-layout-cell/components/divider";
import { isDesignMode } from "../../common/util/util";

// setInterval(()=>{
//   emitEvent(CnSectionCalculateLayout);
// },2000)
var CnLayoutSection = function CnLayoutSection(props) {
  var _ref = props || {},
    children = _ref.children,
    _layout = _ref._layout,
    normalStyle = _ref.normalStyle;
  var slot = _layout === null || _layout === void 0 ? void 0 : _layout.componentSlot;
  var _ref2 = normalStyle || {},
    noPadding = _ref2.noPadding,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  useEffect(function () {
    if (isDesignMode(props)) {
      // 加载切割的交互能力
      initSingletonDivider();
    }
  }, []);
  var extraProps = {};
  if (noPadding) {
    extraProps.style = {
      paddingLeft: 0,
      paddingRight: 0
    };
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UICnLayoutSection, _extends({}, extraProps, rest), slot, children, /*#__PURE__*/React.createElement(AddTile, props)));
};
CnLayoutSection.displayName = 'CnLayoutSection';
export default CnLayoutSection;
export { CnLayoutSection };